function localStorageAvailable(): boolean {
  return typeof window === 'object' && typeof Storage === 'function';
}

export function setLocalStorageRawItem(name: string, value: string) {
  if (!localStorageAvailable()) return false;

  try {
    window.localStorage.setItem(name, value);
    return true;
  } catch {
    // swallowing the "The operation is insecure." error from Safari w/ cookies disabled
    return false;
  }
}

export function setLocalStorageJsonItem(name: string, value: unknown) {
  try {
    return setLocalStorageRawItem(name, JSON.stringify(value));
  } catch {
    // swallowing JSON.stringify error
    return false;
  }
}

export function getLocalStorageRawItem(name: string): string | null {
  if (!localStorageAvailable()) return null;

  try {
    return window.localStorage.getItem(name);
  } catch {
    // swallowing the "The operation is insecure." error from Safari w/ cookies disabled
    return null;
  }
}

export function getLocalStorageJsonItem<T>(name: string): T | null {
  const item = getLocalStorageRawItem(name);
  if (item === null) return null;

  try {
    return JSON.parse(item) as T;
  } catch {
    return null;
  }
}

export function localStorageHasItem(name: string): boolean {
  if (!localStorageAvailable()) return false;

  try {
    return window.localStorage.getItem(name) != null;
  } catch {
    // swallowing the "The operation is insecure." error from Safari w/ cookies disabled
    return false;
  }
}

export function removeLocalStorageItem(
  name: string,
): boolean | null | undefined {
  if (!localStorageAvailable()) return undefined;

  try {
    window.localStorage.removeItem(name);
  } catch {
    // swallowing the "The operation is insecure." error from Safari w/ cookies disabled
    return undefined;
  }

  return true;
}
